export default "__VITE_ASSET__BpG_afso__"